// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CustomerInfo_wrap_3Y2Lu","info_box":"CustomerInfo_info_box_b3Hui","tel_link":"CustomerInfo_tel_link_35STT"};